import React, { FC } from 'react';
import PageContainer from '../components/layout/PageContainer';
import { useTheme } from '../context/ThemeContext';
import { SparklesIcon } from '@heroicons/react/24/solid';
// Import ChatInterface dynamically to avoid circular dependencies
const ChatInterface = React.lazy(() => import('../components/chat/ChatInterface'));

const DeepThoughtPage: FC = () => {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  
  return (
    <PageContainer>
      <div className="mb-6 sm:mb-8 mt-1 sm:mt-1">
        <div className="flex flex-col gap-2 mb-2 sm:mb-4">
          <div className="flex items-center gap-3">
            <SparklesIcon className="h-5 w-5 text-[#00FF84]" />
            <h1 className={`text-xl font-bold ${isLightMode ? 'text-gray-800' : 'text-white'}`}>
              Deep Thought
            </h1>
          </div>
          <p className={`text-sm ${isLightMode ? 'text-gray-700' : 'text-gray-300'}`}>
            Upload your electricity bill to calculate your true cost per kWh with all charges, fees, and taxes included. 
            Deep Thought will break down all costs and help you understand your energy expenses. You can also ask questions about your bill, consumption and production.
          </p>
        </div>
      </div>

      <div className="h-px bg-[#292929] w-full mb-6"></div>
      
      <div className="flex flex-col h-[calc(100vh-230px)]">
        {/* Chat interface */}
        <div className={`flex-1 ${isLightMode ? 'bg-white' : 'bg-[#1D1D1D]'} p-4 rounded-lg border ${isLightMode ? 'border-gray-200' : 'border-[#292929]'} overflow-hidden flex flex-col`} style={{ height: 'calc(100vh - 230px)', scrollbarWidth: 'none' }}>
          <React.Suspense fallback={<div>Loading...</div>}>
            <ChatInterface />
          </React.Suspense>
        </div>
      </div>
    </PageContainer>
  );
};

export default DeepThoughtPage; 